export default {"src":"/_next/static/media/swimming_pool_24.552b7cca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};